import { Col, Grid, Row } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { getCustomComponentProperty } from '@savgroup-front-common/core/helpers';
import { transparentize } from '@savgroup-front-common/primitive/helpers/cssColor';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';
import { SUPPORTED_PROPERTIES } from '@savgroup-front-common/types';

export const $LayoutGrid = styled(Grid)`
  padding: ${spacing('lg')};
`;

export const $ColContainer = styled(Col)`
  margin-top: 'unset';
  @media ${media.minWidth.sm} {
    margin-top: ${spacing(20)};
  }
  position: relative;
  min-height: calc(100vh - 158px);
  margin-bottom: ${spacing(24)};
`;

export const $StepContainer = styled('div')``;

export const $Footer = styled.footer`
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding-left: ${spacing('xl')};
  padding-right: ${spacing('xl')};
  height: ${spacing(16)};
  background-color: ${({ theme }) => {
    return getCustomComponentProperty({
      theme,
      property: SUPPORTED_PROPERTIES.BACKGROUND_COLOR,
      fallback: theme.colors.white,
    });
  }};
  border-top: ${({ theme }) =>
    `${theme.borders.thickness} solid ${transparentize(
      0.75,
      theme.colors.default,
    )}`};
  margin-top: ${spacing('lg')};
  box-shadow: 0 -2px 10px rgba(104, 154, 186, 0.1);
`;

interface RowFooterProps {
  isFirstStep: boolean;
}

export const $RowFooter = styled(Row)<RowFooterProps>`
  display: flex;
  width: 100%;
  justify-content: ${({ isFirstStep }) =>
    isFirstStep ? 'right' : 'space-between'};
  margin-right: unset;
  margin-left: unset;
`;

export const $BannerWrapper = styled.div`
  @media ${media.minWidth.sm} {
    margin-top: ${spacing(16)};
  }
  margin-top: unset;
`;
